async function loadScript(src, id) {
	// prevent double include
	const currentScript = document.getElementById(id);
	if (currentScript) {
		return;
	}

	// inject script
	const script = document.createElement('script');

	script.id = id;
	script.src = src;
	document.getElementsByTagName('body')[0].appendChild(script);

	// Return a promise that resolves when the script loads or rejects when it errors
	await new Promise((resolve, reject) => {
		script.onload = resolve;
		script.onerror = reject;
	});
}

export async function InjectGoogleMaps() {
	const apiKey = document.querySelector("meta[property='app:maps-api-key']").getAttribute('content');

	if (!apiKey) {
		throw new Error('Google Maps API key not found');
	}

	try {
		await loadScript(`https://maps.googleapis.com/maps/api/js?key=${apiKey}&v=3`, 'mapGoogleScript');
		await new Promise((resolve) => setTimeout(resolve, 200)); // Wait for 200ms to ensure the script is executed
		await loadScript('/scripts/bundle-map-plugins.js?v=10', 'mapPlugins');
		return;
	} catch (e) {
		console.error('Error loading map plugins', e);
		throw e;
	}
}
